import schemeApi from './../../api/scheme';
const state = {
    schemeDetails: null,
    schemeId: 'nationalGrid'
};

const getters = {
    getSchemeDetails (state) {
        return state.schemeDetails;
    },
    getSchemeId (state) {
        return state.schemeId;
    },
    getIntroVideoWatched () {
        var b = document.cookie.match('(^|;)\\s*' + 'watchedIntroVideo' + '\\s*=\\s*([^;]+)');
        return b ? b.pop() : '';
    }
};

const actions = {
    getSchemeDetails (context, schemeId) {
        context.commit('setSchemeId', schemeId);
        schemeApi.getScheme(schemeId, (schemeDetails) => {
            context.commit('setSchemeDetails', schemeDetails);
            context.commit('setupFactfind', schemeDetails.company);
        });
    },
    setIntroVideoWatched () {
        schemeApi.watchedIntroVideo();
    },
    requestAdvice () {
        return schemeApi.requestAdvice();
    },
    getCanRequestAdvice () {
        return schemeApi.getCanRequestAdvice();
    }
};

const mutations = {
    setSchemeDetails (state, schemeDetails) {
        state.schemeDetails = schemeDetails;
    },
    setSchemeId (state, schemeId) {
        state.schemeId = schemeId;        
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
